<template>
  <div>
    <common-dialog ref="dialog" :show-save-button="false" width="850px" title="设备日志" edit-title id-key="DeviceLogId"
      :data="data" form-label-width="100px"  :get-data-func="api.info"
      close-on-saved @edit-opened="onEditOpened" @closed="onClosed"
      :before-save="onBeforeSave" @details-opened="onDetailsOpened" @close-saved="$emit('close-saved')">
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="归属机构" >
             {{data.DpName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车辆号">
            {{data.CarNo}}
             </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="设备编号">
            {{data.DeviceNo}}
             </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备类型">
            {{data.DeviceType}}
             </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="IMEI/MAC" >
             {{data.ImeiMac}}
             </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="附件" >
             <el-link v-if="data.FileUrl" @click="download(data.FileUrl)">下载附件</el-link>
             <span v-else>暂无附件</span>
             </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="采集类型" >
              <span>{{data.LogType==0?"日志":"数据库"}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="采集时间" >
              <span>{{$commonJs.toDateString(data.LogDate)}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="完成时间" >
              <span>{{data.FinishTime}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <div>{{data.Remark}}</div>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
          <template #footer>
      <el-button @click="close">关 闭</el-button>
    </template>
    </common-dialog>
  </div>
</template>
<script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
  import api from "@/api/op/devicelog";
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
    },
    data() {
      return {
        data: {
          DeviceLogId: 0,
          DeviceNo: null,
          DeviceType: null,
          DeviceModel: null,
          ImeiMac: null,
          CarNo: null,
          FinishTime: null,
          LogDate: null,
          FileUrl: null,
          Remark: null,
          DpId: 0,
          DpIdChain: "",
          DpName: "",
          Status: 1,
          LogType: 0,
          ReviewStatus: 0,
        },
        api,
        props: {
          value: "DpId",
          label: "DpName",
          children: "children",
        },
      };
    },
    computed: {
    },
    methods: {
      download(url) {
        // this.attach.downloadByUrl("/Template/" + url, "设备附件");
        window.open(window.location.origin + "/api" + url);
      },
      onEditOpened(data) {
      },
      onDetailsOpened(row) {
        this.onEditOpened(row)
      },
      onBeforeSave() {
    
      },
      onClosed() {
      },
    },
  };
</script>
<style lang="scss" scoped>
  /deep/ .el-tree .el-tree-node .el-tree-node__content {
    height: 35px;
  }

  /deep/ .form-border {
    .el-form-item__content {
      border: 1px solid #ddd;
      border-radius: 3px;
    }
  }
</style>